<template>

    <footer class="footer-bloc">

        <div class="footer-container">

            <div class="footer-flex footer-flex-2">

                <img alt="logo" class="footer-logo" src="/img/logo/large/white.svg">

                <lang-switch></lang-switch>

            </div>

            <div class="footer-flex">

                <h2 class="footer-section">{{ $t('footer_company') }}</h2>

                <a :href="makeHref('/about')" class="footer-link" @click="footerEventGA('about')">{{ $t('footer_about_us') }}
                </a>

                <a :href="makeHref('/foxintelligence')" class="footer-link" @click="footerEventGA('foxintelligence')">{{
                        $t('footer_foxintelligence')
                    }}
                </a>

                <a :href="makeHref('/press')" class="footer-link" @click="footerEventGA('press')">{{ $t('footer_press') }}
                </a>

                <div class="footer-space"></div>

            </div>

            <div class="footer-flex">

                <h2 class="footer-section">{{ $t('footer_resources') }}</h2>

                <a :href="makeHref('/privacy')" class="footer-link" @click="footerEventGA('privacy')">{{ $t('footer_privacy') }}
                </a>

                <a :href="makeHref('/terms')" class="footer-link" @click="footerEventGA('terms')">{{ $t('footer_terms') }}
                </a>

                <a :href="makeHref('/faq')" class="footer-link" @click="footerEventGA('faq')">{{ $t('footer_faq') }}
                </a>

                <a :href="makeHref('/my-data')" class="footer-link" @click="footerEventGA('my-data')">{{ $t('new_footer_data_use') }}
                </a>

                <a v-if="isDeutsch" :href="makeHref('/impressum')" class="footer-link" @click="footerEventGA('impressum')">{{ $t('footer_impressum') }}
                </a>

                <div class="footer-space"></div>

            </div>

            <div class="footer-flex">


<!--                <a v-if="isFrench" class="footer-section pointer" href="https://cleanfox.io/blog/fr/" target="_blank"> {{ $t('footer_blog') }}</a>-->
<!--                <a v-else class="footer-section pointer" href="https://cleanfox.io/blog/en/" target="_blank">{{ $t('footer_blog') }}</a>-->

<!--                <a v-if="isFrench" href="https://cleanfox.io/blog/pollution-numerique-fr/" class="footer-link" target="_blank">{{ $t('footer_pollution')}}</a>-->
<!--                <a v-else href="https://cleanfox.io/blog/digital-pollution-en/" class="footer-link" target="_blank">{{ $t('footer_pollution')}}</a>-->

<!--                <a v-if="isFrench" href="https://cleanfox.io/blog/astuces-fr/" class="footer-link" target="_blank">{{ $t('footer_tips') }}</a>-->
<!--                <a v-else href="https://cleanfox.io/blog/tips-en/" class="footer-link" target="_blank">{{ $t('footer_tips') }}</a>-->

<!--                <a v-if="isFrench" href="https://cleanfox.io/blog/actualite-fr/" class="footer-link" target="_blank">{{ $t('footer_news') }}</a>-->
<!--                <a v-else href="https://cleanfox.io/blog/cleanfox-news-en/" class="footer-link" target="_blank">{{ $t('footer_news') }}</a>-->

<!--                <a v-if="isFrench" href="https://cleanfox.io/blog/astuces-fr/se-connecter-a-sa-boite-mail-hotmail/" class="footer-link" target="_blank">{{ $t('footer_connect_hotmail') }}</a>-->
<!--                <a v-else href="https://cleanfox.io/blog/tips-en/connect-to-your-hotmail-mailbox/" class="footer-link" target="_blank">{{ $t('footer_connect_hotmail') }}</a>-->

            </div>

            <div class="footer-space"></div>

            <div class="footer-flex">

                <mq-layout :mq="['sm', 'md']" class="footer-flex">

                    <a class="footer-section" href="https://app.adjust.com/uez2im"
                       target="_blank">{{
                            $t('footer_android_app')
                        }}</a>

                    <a class="footer-section" href="https://app.adjust.com/uez2im"
                       target="_blank">{{ $t('footer_ios_app') }}</a>

                </mq-layout>


                <mq-layout class="footer-flex" mq="lg">

                    <h2 class="footer-section">{{ $t('footer_our_app') }}</h2>

                    <a class="footer-link" href="https://app.adjust.com/uez2im"
                       target="_blank">{{
                            $t('footer_android_app')
                        }}</a>

                    <a class="footer-link" href="https://app.adjust.com/uez2im"
                       target="_blank">{{ $t('footer_ios_app') }}</a>


                </mq-layout>


                <mq-layout class="footer-flex" mq="lg">

                    <h2 class="footer-section">{{ $t('footer_community') }}</h2>

                </mq-layout>

                <div class="footer-media-container">

                    <a href="https://www.facebook.com/cleanfox/" target="_blank">
                        <img alt="facebook" class="footer-media pointer" src="/img/share/little-facebook-white.svg">
                    </a>

                    <a :href="`https://twitter.com/cleanfoxapp?lang=${ lang }`" target="_blank">
                        <img alt="twitter" class="footer-media pointer" src="/img/share/little-twitter-white.svg">
                    </a>

                    <a :href="`https://www.instagram.com/cleanfox_/?hl=${ lang }`" target="_blank">
                        <img alt="instagram" class="footer-media pointer" src="/img/share/little-instagram-white.svg">
                    </a>

                </div>

            </div>

        </div>

        <div class="bottom-bloc-container">

            <div class="bottom-bloc">

                <span class="copyright">{{ $t('footer_copyright', 0, {year}) }}</span>

                <span class="made_with_love">{{ $t('footer_with_love') }}</span>

            </div>

        </div>

    </footer>

</template>

<script>

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'

import LangSwitch from '@/components/LangSwitch'

export default {

    name: 'footer-landing',

    components: {LangSwitch},

    computed: {

        isDeutsch() {
            return I18n.get(this) === 'de'
        },

        isFrench() {
            return I18n.get(this) === 'fr'
        },

        lang() {
            return I18n.get(this)
        }
    },

    data() {
        return {
            year: new Date().getFullYear()
        }
    },

    methods: {

        footerEventGA(page) {

            Tag.clickGA(this, page)
        },

        makeHref(url) {
            return `/${I18n.get(this)}${url}`
        }
    }

}

</script>

<style lang="scss" scoped>

.footer-bloc {
    background-color: $blue;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.footer-container {
    padding: 26px 16px 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: $max-wrapper;
    @media screen and (min-width: $above-tablet-length) {
        flex-direction: row;
        padding: 40px 32px 60px;
    }
}

.footer-logo {
    height: 57px;
    margin-left: -4px;
    margin-bottom: 18px;
}

.footer-section {
    font-size: 16px;
    font-weight: bold;
    color: $white;
    margin-top: 16px;
    margin-bottom: 6px;
}

.footer-link {
    font-size: 14px;
    color: $white;
    margin-top: 16px;
    cursor: pointer;
    padding-right: 16px;
    @media screen and (min-width: $above-tablet-length) {
        text-align: left;
    }
}

.footer-space {
    height: 13px;
}

.footer-media-container {
    margin-top: 19px;
    display: flex;
}

.footer-media {
    margin-right: 25px;
    width: 24px;
    object-fit: contain;
}

.bottom-bloc-container {
    width: 100%;
    padding: 24px 0 20px;
    background-color: rgb(58, 121, 164);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: $above-tablet-length) {
        padding: 24px 32px 19px;
    }
}

.bottom-bloc {
    display: flex;
    flex-direction: column;
    max-width: $max-wrapper;
    justify-content: space-around;
    height: 100%;
    @media screen and (min-width: $above-tablet-length) {
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}

.copyright {
    font-size: 12px;
    color: $white;
    opacity: 0.6;
}

.made_with_love {
    font-size: 14px;
    color: $white;
    margin-top: 28px;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 0px;
    }
}

.footer-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
}

.footer-flex-2 {
    @media screen and (min-width: $above-tablet-length) {
        flex: 2;
    }
}

</style>
